var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#7A8E96",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.195 4.105 3.67 20.63M20.195 20.695 3.67 4.17"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-close.4209b56620067f559a3440ee604da6d4.svg";